import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { API_BASE_URL } from '../config';

function CallbackForm({ onClose }) {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
    type: 'general'
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const sendToCleverSite = () => {
    // Create message with form data
    const typeLabels = {
      'general': 'Общий запрос',
      'event': 'Информация о мероприятии',
      'catalog': 'Информация о произведении',
      'partnership': 'Возможность партнерства',
      'visit': 'Запрос частного визита'
    };

    const message = `Пожалуйста, свяжитесь со мной:
Тип запроса: ${typeLabels[formData.type] || formData.type}
Имя: ${formData.name}
Email: ${formData.email}
Телефон: ${formData.phone}
Сообщение: ${formData.message || 'Не указано'}`;

    // Open chat and send message
    if (window.cleversiteEvent) {
      window.cleversiteEvent.trigger('openWidgetChat');
    }

    setTimeout(() => {
      const chatInput = document.querySelector('.clv_input_message');
      if (chatInput) {
        chatInput.textContent = message;

        setTimeout(() => {
          const sendButton = document.querySelector('.cleversite_clever_button-send');
          if (sendButton) {
            sendButton.click();

            // Clear the input after sending
            setTimeout(() => {
              chatInput.textContent = '';
            }, 100);
          }
        }, 100);
      }
    }, 500);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic validation
    if (!formData.name.trim() || !formData.email.trim() || !formData.phone.trim()) {
      setError(t('fillRequiredFields'));
      return;
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      setError(t('validEmailRequired'));
      return;
    }

    setLoading(true);
    setError(null);

    try {
      // Send to backend
      const response = await fetch(`${API_BASE_URL}/callback-requests`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      if (!response.ok) {
        throw new Error('Failed to submit callback request');
      }

      // Also send to CleverSite
      sendToCleverSite();
      
      setSuccess(true);
      setFormData({
        name: '',
        email: '',
        phone: '',
        message: '',
        type: 'general'
      });
      // Close menu directly, no success screen
      onClose();

    } catch (err) {
      console.error('Failed to submit callback request:', err);
      setError(t('submissionFailed'));
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div style={{
        padding: '60px 40px',
        textAlign: 'center'
      }}>
        <div style={{
          fontSize: '48px',
          marginBottom: '20px'
        }}>
          ✅
        </div>
        <h2 style={{
          fontSize: '24px',
          fontWeight: 'bold',
          color: '#059669',
          marginBottom: '10px'
        }}>
          {t('requestSubmitted')}
        </h2>
        <p style={{
          color: '#6b7280',
          fontSize: '16px'
        }}>
          {t('contactSoon')}
        </p>
      </div>
    );
  }

  return (
    <div style={{ padding: '40px' }}>
      <div style={{
        textAlign: 'center',
        marginBottom: '30px'
      }}>
        <div style={{ fontSize: '48px', marginBottom: '15px' }}>📞</div>
        <p style={{
          color: '#6b7280',
          fontSize: '16px',
          lineHeight: '1.5'
        }}>
          Мы рады услышать от вас! Заполните форму ниже, и мы свяжемся с вами как можно скорее.
        </p>
      </div>

      <form onSubmit={handleSubmit}>
        <div style={{
          display: 'grid',
          gap: '20px',
          maxWidth: '500px',
          margin: '0 auto'
        }}>
          {/* Request Type */}
          <div>
            <label style={{
              display: 'block',
              marginBottom: '8px',
              fontWeight: '600',
              color: '#374151'
            }}>
              Чем мы можем помочь? *
            </label>
            <select
              name="type"
              value={formData.type}
              onChange={handleChange}
              required
              style={{
                width: '100%',
                padding: '12px 15px',
                border: '2px solid #e5e7eb',
                borderRadius: '8px',
                fontSize: '14px',
                backgroundColor: 'white'
              }}
            >
              <option value="general">Общий запрос</option>
              <option value="event">Информация о мероприятии</option>
              <option value="catalog">Информация о произведении</option>
              <option value="partnership">Возможность партнерства</option>
              <option value="visit">Запрос частного визита</option>
            </select>
          </div>

          {/* Name */}
          <div>
            <label style={{
              display: 'block',
              marginBottom: '8px',
              fontWeight: '600',
              color: '#374151'
            }}>
              {t('fullName')} *
            </label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder="Ваше полное имя"
              style={{
                width: '100%',
                padding: '12px 15px',
                border: '2px solid #e5e7eb',
                borderRadius: '8px',
                fontSize: '14px'
              }}
            />
          </div>

          {/* Email */}
          <div>
            <label style={{
              display: 'block',
              marginBottom: '8px',
              fontWeight: '600',
              color: '#374151'
            }}>
              {t('emailAddress')} *
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="ваш@email.com"
              style={{
                width: '100%',
                padding: '12px 15px',
                border: '2px solid #e5e7eb',
                borderRadius: '8px',
                fontSize: '14px'
              }}
            />
          </div>

          {/* Phone */}
          <div>
            <label style={{
              display: 'block',
              marginBottom: '8px',
              fontWeight: '600',
              color: '#374151'
            }}>
              {t('phoneNumber')} *
            </label>
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              required
              placeholder="Ваш номер телефона"
              style={{
                width: '100%',
                padding: '12px 15px',
                border: '2px solid #e5e7eb',
                borderRadius: '8px',
                fontSize: '14px'
              }}
            />
          </div>

          {/* Message */}
          <div>
            <label style={{
              display: 'block',
              marginBottom: '8px',
              fontWeight: '600',
              color: '#374151'
            }}>
              {t('message')} ({t('optional')})
            </label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder="Расскажите подробнее о вашем запросе..."
              rows={4}
              style={{
                width: '100%',
                padding: '12px 15px',
                border: '2px solid #e5e7eb',
                borderRadius: '8px',
                fontSize: '14px',
                resize: 'vertical',
                fontFamily: 'inherit'
              }}
            />
          </div>

          {/* Error Message */}
          {error && (
            <div style={{
              padding: '15px',
              backgroundColor: '#fef2f2',
              border: '1px solid #fecaca',
              borderRadius: '8px',
              color: '#dc2626',
              fontSize: '14px'
            }}>
              {error}
            </div>
          )}

          {/* Submit Button */}
          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              padding: '15px',
              backgroundColor: loading ? '#9ca3af' : '#2563eb',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: loading ? 'not-allowed' : 'pointer',
              transition: 'background-color 0.2s ease'
            }}
            onMouseEnter={(e) => {
              if (!loading) {
                e.target.style.backgroundColor = '#1d4ed8';
              }
            }}
            onMouseLeave={(e) => {
              if (!loading) {
                e.target.style.backgroundColor = '#2563eb';
              }
            }}
          >
            {loading ? t('submitting') : t('submit')}
          </button>

          <div style={{
            textAlign: 'center',
            fontSize: '12px',
            color: '#6b7280',
            marginTop: '10px'
          }}>
            Мы обычно отвечаем в течение 24 часов в рабочие дни.
          </div>
        </div>
      </form>
    </div>
  );
}

export default CallbackForm;